class VideoPlayerElement extends HTMLElement {
  connectedCallback() {
    const video = this.querySelector("video");
    if (!video) return;

    const sizes = JSON.parse(this.getAttribute("sizes") || "[]")
      .sort((a, b) => a.size - b.size);
    if (sizes.length) {
      const needed = this.clientWidth * devicePixelRatio;
      const chosen = sizes.find((s) => s.size >= needed) || sizes[sizes.length - 1];
      video.src = chosen.file;
    }

    this.preloadObserver = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            video.preload = "auto";
            this.preloadObserver.disconnect();
            this.preloadObserver = null;
          }
        }
      },
      { rootMargin: "25%" },
    );
    this.preloadObserver.observe(this);

    this.playObserver = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) video.play();
          else video.pause();
        }
      },
      { threshold: 0.25 },
    );
    this.playObserver.observe(this);
  }

  disconnectedCallback() {
    if (this.preloadObserver) {
      this.preloadObserver.disconnect();
      this.preloadObserver = null;
    }
    if (this.playObserver) {
      this.playObserver.disconnect();
      this.playObserver = null;
    }
    const video = this.querySelector("video");
    if (video) video.pause();
  }
}

customElements.define("video-player", VideoPlayerElement);
